import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconCircleEmpty: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconCircleEmpty" {...props}>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10.875c2.69239 0 4.875-2.18261 4.875-4.875S8.69239 1.125 6 1.125 1.125 3.30761 1.125 6 3.30761 10.875 6 10.875zM6 12c3.31371 0 6-2.68629 6-6S9.31371 0 6 0 0 2.68629 0 6s2.68629 6 6 6z"
      />
    </svg>
  </IconSVG>
)
